import { functions } from "../firebase";

// Client wrappers for the first-party LinkedIn callables (functions/src/
// linkedinPublishing.ts). Mirrors tiktokConnection.ts: tokens NEVER cross this
// boundary — the connection read returns only display chrome, and publishing is
// done entirely server-side.

export type LinkedInConnection = {
  connected: boolean;
  name?: string;
  picture?: string;
  email?: string;
  scopes?: string[];
};

export type LinkedInPublishResult = {
  ok: boolean;
  postUrn?: string;
};

// Read the community's LinkedIn connection state for the connect panel.
export const getLinkedInConnection = async (
  communityId: string
): Promise<LinkedInConnection> => {
  const callable = functions.httpsCallable("linkedinGetConnection");
  const res = await callable({ communityId });
  return res.data as LinkedInConnection;
};

// Start OAuth: returns the authorize URL to open in a popup.
export const startLinkedInAuth = async (
  communityId: string
): Promise<{ url: string }> => {
  const callable = functions.httpsCallable("linkedinStartAuth");
  const res = await callable({ communityId });
  return res.data as { url: string };
};

// Finish OAuth: the /auth/linkedin/callback route calls this with the ?code and
// ?state LinkedIn returned.
export const completeLinkedInAuth = async (params: {
  code: string;
  state: string;
}): Promise<LinkedInConnection> => {
  const callable = functions.httpsCallable("linkedinCompleteAuth");
  const res = await callable(params);
  return res.data as LinkedInConnection;
};

// Publish a post to the coach's LinkedIn feed. Give a MediaProject id (to pull
// its caption / first slide) OR explicit text.
export const publishLinkedInPost = async (params: {
  communityId: string;
  text?: string;
  projectId?: string;
  imageUrl?: string;
  visibility?: "PUBLIC" | "CONNECTIONS";
}): Promise<LinkedInPublishResult> => {
  const callable = functions.httpsCallable("linkedinCreatePost", {
    timeout: 120000,
  });
  const res = await callable(params);
  return res.data as LinkedInPublishResult;
};

// Clear the community's LinkedIn connection.
export const disconnectLinkedIn = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("linkedinDisconnect");
  const res = await callable({ communityId });
  return res.data as { connected: boolean };
};
